import { ModuleObject } from "@/module/ModuleObject";
import { GFFObject } from "@/resource/GFFObject";
import * as THREE from "three";
import { OdysseyModel3D } from "@/three/odyssey";
import { NWScriptInstance } from "@/nwscript/NWScriptInstance";
import { GameState } from "@/GameState";
import { OdysseyModel, OdysseyModelAnimationManager } from "@/odyssey";
import { NWScript } from "@/nwscript/NWScript";
import { IModelListItem } from "@/interface/module/minigame/IModelListItem";
import { ModuleObjectType } from "@/enums/module/ModuleObjectType";
import { MDLLoader } from "@/loaders";
import { ModuleMGGunBank } from "@/module/ModuleMGGunBank";
import { ModuleObjectScript } from "@/enums/module/ModuleObjectScript";

/**
* ModuleMGEnemy class.
* 
* Class representing an enemy object found in minigame modules.
* 
* KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
* 
* @file ModuleMGEnemy.ts
* @author KobaltBlu <https://github.com/KobaltBlu>
* @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
* @memberof KotOR
*/
export class ModuleMGEnemy extends ModuleObject {
  gunBanks: ModuleMGGunBank[] = [];
  models: OdysseyModel3D[] = [];
  track: THREE.Object3D;
  animationManagers: OdysseyModelAnimationManager[] = [];
  gun_hook: THREE.Object3D;

  modelProps: IModelListItem[] = [];

  gear: number;
  timer: number;
  jumpVelcolity: number;
  boostVelocity: number;
  invince: number;
  alive: boolean;
  sphere_geom: THREE.Mesh;
  sphere_radius: number;
  hit_points: number;
  died: any;
  invince_period: number;
  accel_secs: any;
  bump_damage: any;
  cameraName: any;
  cameraRotate: any;
  max_hps: any;
  maximum_speed: any;
  minimum_speed: any;
  num_loops: any;
  trackName: any;

  collided: boolean = false;

  constructor(template: GFFObject){
    super();
    this.objectType |= ModuleObjectType.ModuleMGEnemy;
    this.template = template;

    this.gunBanks = [];
    this.track = new THREE.Object3D();

    this.setTrack(this.track);

    this.gear = -1;
    this.timer = 0;
    this.jumpVelcolity = 0;
    this.boostVelocity = 0;
    this.invince = 0;

    this.box = new THREE.Box3();
    this.model = this.container as any;

    this.alive = true;

    //this.model.children[2].rotation.y = .1

    const geometry = new THREE.SphereGeometry( 1, 16, 16 );
    const material = new THREE.MeshBasicMaterial( { color: 0xFF0000 } );
    material.transparent = true;
    material.opacity = 0.15;
    this.sphere_geom = new THREE.Mesh( geometry, material );
    this.sphere_geom.visible = false;

  }

  setTrack(model = new THREE.Object3D()){
    this.track = model;
    this.container.removeFromParent();

    try{
      this.track.getObjectByName('modelhook').add(this.container);
    }catch(e){

    }

  }

  update(delta: number = 0){

    this.invince -= delta;
    if(this.invince < 0) this.invince = 0;

    this.sphere.radius = this.sphere_radius;
    // this.model.getWorldPosition(this.position);
    this.sphere.center.copy(this.position);

    this.sphere_geom.scale.setScalar(this.sphere_radius);
    this.sphere_geom.position.copy(this.sphere.center);

    for(let i = 0; i < this.animationManagers.length; i++){
      const aManager = this.animationManagers[i];
      aManager.updateAnimation(aManager.currentAnimation, aManager.currentAnimationState, delta);
    }

    for(let i = 0; i < this.models.length; i++){
      let child_model = this.models[i];
      if(child_model instanceof OdysseyModel3D && child_model.bonesInitialized && child_model.visible){

        if(this.hit_points > 0){
          if(!child_model.animationManager.currentAnimation || (child_model.animationManager.currentAnimation.name != 'Ready_01' && child_model.animationManager.currentAnimation.name != 'damage')){
            child_model.playAnimation('Ready_01', false);
          }
        }else if(!this.alive && !this.died){
          child_model.playAnimation('die', false);
          this.died = true;
        }else{
          if(!child_model.animationManager.currentAnimation){
            //child_model.visible = false;
          }
        }

        child_model.update(delta);
      }
    }

    if(this.hit_points <= 0 && this.alive){
      this.alive = false;
      console.log('MGEnemy death', this);
      const onDeath = this.scripts[ModuleObjectScript.MGEnemyOnDeath];
      if(onDeath){
        onDeath.run(this);
      }
    }

    this.box.setFromObject(this.models[0]);

    if(this.track instanceof OdysseyModel3D){
      if(!this.track.animationManager.currentAnimation && this.alive){
        this.track.playAnimation(0, true);
      }else if(!this.alive && this.track.animationManager.currentAnimation){
        this.track.stopAnimation();
      }
      this.track.update(delta);
    }
        
    for(let i = 0; i < this.gunBanks.length; i++){
      this.gunBanks[i].update(delta);
      if(this.alive){
        this.container.getWorldPosition(GameState.raycaster.ray.origin);
        this.container.getWorldDirection(GameState.raycaster.ray.direction);
        if(GameState.raycaster.ray.intersectsSphere(GameState.module.area.miniGame.player.sphere)){
          this.gunBanks[i].fire();
        }
      }
    }

  }

  updatePaused(delta: number = 0){
    
  }

  damage(damage = 0){
    if(this.alive){
      this.hit_points -= damage;
      let model: OdysseyModel3D
      for(let i = 0; i < this.models.length; i++){
        model = this.models[i];
        if(model instanceof OdysseyModel3D){
          if(model.bonesInitialized && model.visible){
            model.playAnimation('damage', false);
          }
        }
      }
      this.onDamaged();
    }
  }

  adjustHitPoints(nHP = 0, nAbsolute = 0){
    this.hit_points += nHP;
  }

  startInvulnerability(){
    this.invince = this.invince_period || 0;
  }

  playAnimation(name = '', n1 = 0, n2 = 0, n3 = 0){
    //I think n3 may be loop
    for(let i = 0; i < this.models.length; i++){
      const model = this.models[i];
      const anim = model.odysseyAnimationMap.get(name.toLowerCase().trim());
      if(anim){
        if(n3){
          console.log(anim);
          const animManager = new OdysseyModelAnimationManager(model);
          const state = animManager.createAnimationState();
          state.loop = true;
          animManager.setCurrentAnimation(anim, state);
          this.animationManagers.push(animManager);
        }else{
          model.playAnimation(anim, false);
        }
      }
    }
  }

  removeAnimation(name = ''){

    let model: OdysseyModel3D
    for(let i = 0; i < this.models.length; i++){
      model = this.models[i];
      if(model instanceof OdysseyModel3D){
        let anim = model.odysseyAnimationMap.get(name.toLowerCase().trim());

        if(anim){
          let animLoopIdx = model.animLoops.indexOf(anim);
          if(animLoopIdx >= 0){
            model.animLoops.splice(animLoopIdx, 1);
          }

          if(model.animationManager.currentAnimation == anim){
            model.stopAnimation();
          }

        }
      }
    }

  }

  updateCollision(delta = 0){
    this.track.updateMatrixWorld();
  }

  async load(){
    this.initProperties();
    GameState.scene.add(this.sphere_geom);
    return this.template;
  }

  async loadModel (){
    for(let i = 0; i < this.modelProps.length; i++){
      const item = this.modelProps[i];
      const resref = item.model.replace(/\0[\s\S]*$/g,'').toLowerCase();
      const mdl = await MDLLoader.loader.load(resref);
      const model = await OdysseyModel3D.FromMDL(mdl, {
        context: this.context,
        castShadow: true,
        receiveShadow: true
      });
      try{
        this.models.push(model);
        this.container.add(model);  
        model.name = item.model;

      }catch(e){
        console.error(e);
      }
    }
  }

  async loadGunBanks(){
    for(let i = 0; i < this.gunBanks.length; i++){
      const gunbank = this.gunBanks[i];
      await gunbank.load();
      this.gun_hook = this.getGunHook(gunbank.bankID);
      if(this.gun_hook instanceof THREE.Object3D){
        this.gun_hook.add(gunbank.model);
      }
    }
  }

  getGunHook(bankID: number): THREE.Object3D | undefined {
    return this.container.getObjectByName('gunbank'+bankID) as THREE.Object3D;
  }

  onAnimEvent(){
    const onAnimEvent = this.scripts[ModuleObjectScript.MGEnemyOnAnimEvent];
    if(!onAnimEvent){ return; }
    onAnimEvent.run(this, 0);
  }

  onCreate(){
    const onCreate = this.scripts[ModuleObjectScript.MGEnemyOnCreate];
    if(!onCreate){ return; }
    onCreate.run(this, 0);
  }

  onDamaged(){
    const onDamage = this.scripts[ModuleObjectScript.MGEnemyOnDamage];
    if(!onDamage){ return true; }
    onDamage.run(this, 0);
    return true;
  }

  onFire(){
    const onFire = this.scripts[ModuleObjectScript.MGEnemyOnFire];
    if(!onFire){ return; }
    onFire.run(this, 0);
  }

  onAccelerate(){
    const onAccelerate = this.scripts[ModuleObjectScript.MGEnemyOnAccelerate];
    if(!onAccelerate){ return; }
    onAccelerate.run(this, 0);
  }

  onHitBullet(){
    const onHitBullet = this.scripts[ModuleObjectScript.MGEnemyOnHitBullet];
    if(!onHitBullet){ return; }
    onHitBullet.run(this, 0);
  }

  onHitFollower(){
    const onHitFollower = this.scripts[ModuleObjectScript.MGEnemyOnHitFollower];
    if(!onHitFollower){ return; }
    onHitFollower.run(this, 0);
  }

  onHitObstacle(){
    const onHitObstacle = this.scripts[ModuleObjectScript.MGEnemyOnHitObstacle];
    if(!onHitObstacle){ return; }
    onHitObstacle.run(this, 0);
  }

  onTrackLoop(){
    const onTrackLoop = this.scripts[ModuleObjectScript.MGEnemyOnTrackLoop];
    if(!onTrackLoop){ return; }
    onTrackLoop.run(this, 0);
  }

  loadScripts (){
    const scriptKeys = [
      ModuleObjectScript.MGEnemyOnAccelerate,
      ModuleObjectScript.MGEnemyOnAnimEvent,
      ModuleObjectScript.MGEnemyOnBrake,
      ModuleObjectScript.MGEnemyOnCreate,
      ModuleObjectScript.MGEnemyOnDamage,
      ModuleObjectScript.MGEnemyOnDeath,
      ModuleObjectScript.MGEnemyOnFire,
      ModuleObjectScript.MGEnemyOnHeartbeat,
      ModuleObjectScript.MGEnemyOnHitBullet,
      ModuleObjectScript.MGEnemyOnHitFollower,
      ModuleObjectScript.MGEnemyOnHitObstacle,
      ModuleObjectScript.MGEnemyOnHitWorld,
      ModuleObjectScript.MGEnemyOnTrackLoop,
    ];

    const scriptsNode = this.template.getFieldByLabel('Scripts')?.getFieldStruct();
    if(scriptsNode){
      for(const scriptKey of scriptKeys){
        if(!scriptsNode.hasField(scriptKey)){ continue; }
        const resRef = scriptsNode.getFieldByLabel(scriptKey).getValue();
        if(!resRef){ continue; }
        const nwscript = GameState.NWScript.Load(resRef);
        if(!nwscript){ 
          console.warn(`ModuleMGEnemy.loadScripts: Failed to load script [${scriptKey}]:${resRef} for object ${this.name}`);
          continue; 
        }
        nwscript.caller = this;
        this.scripts[scriptKey] = nwscript;
      }
    }
  }

  initProperties(){
    if(this.template.RootNode.hasField('Accel_Secs'))
      this.accel_secs = this.template.getFieldByLabel('Accel_Secs').getValue();

    if(this.template.RootNode.hasField('Bump_Damage'))
      this.bump_damage = this.template.getFieldByLabel('Bump_Damage').getValue();

    if(this.template.RootNode.hasField('Camera'))
      this.cameraName = this.template.getFieldByLabel('Camera').getValue();

    if(this.template.RootNode.hasField('CameraRotate'))
      this.cameraRotate = this.template.getFieldByLabel('CameraRotate').getValue();

    if(this.template.RootNode.hasField('Hit_Points'))
      this.hit_points = this.template.getFieldByLabel('Hit_Points').getValue();

    if(this.template.RootNode.hasField('Invince_Period'))
      this.invince_period = this.template.getFieldByLabel('Invince_Period').getValue();

    if(this.template.RootNode.hasField('Max_HPs'))
      this.max_hps = this.template.getFieldByLabel('Max_HPs').getValue();

    if(this.template.RootNode.hasField('Maximum_Speed'))
      this.maximum_speed = this.template.getFieldByLabel('Maximum_Speed').getValue();

    if(this.template.RootNode.hasField('Minimum_Speed'))
      this.minimum_speed = this.template.getFieldByLabel('Minimum_Speed').getValue();

    if(this.template.RootNode.hasField('Num_Loops'))
      this.num_loops = this.template.getFieldByLabel('Num_Loops').getValue();

    if(this.template.RootNode.hasField('Sphere_Radius'))
      this.sphere_radius = this.template.getFieldByLabel('Sphere_Radius').getValue();

    if(this.template.RootNode.hasField('Track'))
      this.trackName = this.template.getFieldByLabel('Track').getValue();


    if(this.template.RootNode.hasField('Models')){
      let models = this.template.getFieldByLabel('Models').getChildStructs();
      for(let i = 0; i < models.length; i++){
        let modelStruct = models[i];
        this.modelProps.push({
          model: modelStruct.getFieldByLabel('Model').getValue(),
          rotating: modelStruct.getFieldByLabel('RotatingModel').getValue() ? true : false
        });
      }
    }

    if(this.template.RootNode.hasField('Gun_Banks')){
      const gun_banks = this.template.getFieldByLabel('Gun_Banks').getChildStructs();
      for(let i = 0; i < gun_banks.length; i++){
        this.gunBanks.push(
          new ModuleMGGunBank(
            GFFObject.FromStruct(gun_banks[i]),
            this,
            false
          )
        );
      }
    }

    this.initialized = true;

  }


}
